import React from 'react'
import { render, MARK_LINK } from 'storyblok-rich-text-react-renderer';
import Button from 'src/components/Button'
import Video from 'src/components/Custom/Video'
import ContentCtaCentered from 'src/components/ContentCtaCentered'
import { Link } from 'gatsby'
import resolveLink from 'src/utils/resolveLink'

const RichText = ({ children }) => {
    return render(children, {
        // https://github.com/claus/storyblok-rich-text-react-renderer
        markResolvers: {
            [MARK_LINK]: (children, props) => {
                const { href, target, linktype } = props;
                const isExternal = linktype !== 'story'
                if (linktype === 'email') {
                    // Email links: add `mailto:` scheme and map to <a>
                    return <a href={`mailto:${href}`}>{children}</a>;
                }
                if (isExternal || target === '_blank') {
                    // External links: Check for external link and _blank and map to <a>
                    return <a href={isExternal ? href : resolveLink(href)} target={target}>{children}</a>;
                }
                // Internal links: map to <Link>
                return <Link to={resolveLink(href)}>{children}</Link>;
            }
        },
        blokResolvers: {
            'button' : (props) => <Button to={props.button_target.cached_url} className="!text-white">{props.button_text}</Button>,
            'video' : (props) => 
            <Video 
                blok={{ 
                    thumbnail: props.thumbnail,
                    video: props.video,
                    cdn_video: props.cdn_video,
                    isContent: true
                }}
                className="!text-white"
            />,
            'content-cta-centered' : (props) => 
            <ContentCtaCentered 
                blok={{ 
                    title: props.title,
                    content: props.content,
                    isContent: true
                }}
                className="!text-white"
            />,
        }
    });
}

export default RichText